import { C, FONTS } from '../../tokens/design';

const STATUS_MAP = {
  open:                [C.red, 'transparent', false],
  remediation_claimed: [C.amb, C.ambBg, false],
  verified:            [C.grn, C.grnBg, false],
  accepted_risk:       [C.gry, C.gryBg, false],
  reopened:            ['#fff', C.red, true],
  possibly_remediated: [C.grn, C.grnBg, false],
  suppressed:          [C.amb, C.ambBg, false],
};

export default function StatusBadge({ value }) {
  const v = value || 'open';
  const [color, bg, solid] = STATUS_MAP[v] || STATUS_MAP.open;
  const label = v.replace(/_/g, ' ').replace(/\b\w/g, x => x.toUpperCase());
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center',
      padding: '2px 8px', borderRadius: 9999,
      fontSize: 11, fontWeight: 500, fontFamily: FONTS.mono,
      color, background: bg,
      border: solid ? 'none' : `1px solid ${color}55`,
    }}>{label}</span>
  );
}
